import React, {Component} from 'react'
import {withRouter} from "react-router-dom"
import LoanSanctionPageUI from "./LoanSanctionPageUI"
import CacheManager from "../../../cache/CacheManager"
import CacheKeys from "../../../cache/CacheKeys"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"
import LoanAPIClient from "../../../components/finapp/loan/LoanAPIClient"

class LoanSanctionPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      cibilRankList: null,
      loan: null,
    }
  }

  render() {
    return (
      <LoanSanctionPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        cibilRankList={this.state.cibilRankList}
        loan={this.state.loan}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getCibilRanks(context)
    this.getLoan(context)
  }

  getLoan(context) {
    RestApiUtils.get(
      this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}`,
      this.getLoanCallback
    )
  }

  getLoanCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      loan: response.loan,
    })
  }

  getCibilRanks(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/cibilRanks`,
      cacheKey: CacheKeys.CibilRanks(),
      callback: this.getCibilRanksCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getCibilRanksCallback = (response) => {
    let cibilRankList = response.cibilRankList.map(cibilRank => ({key: cibilRank.code, value: cibilRank.name}))
    this.setState({cibilRankList: cibilRankList})
  }

}

export default withRouter(LoanSanctionPageSF)
